import { getAddress, zeroAddress } from "viem";
function asset(value) {
    return Object.freeze({ ...value, token: getAddress(value.token) });
}
/** UI presets are not Factory authorization. Check paymentTokenAllowed before creation. */
export const FUNDRAISING_ASSETS = Object.freeze({
    56: Object.freeze([
        asset({
            symbol: "BEM",
            token: "0x5ce033b2bfca3af30b3e8c8457deaf776a8b695a",
            decimals: 8,
            kind: "erc20",
        }),
        // Issuer: https://docs.worldlibertyfinancial.com/usd1-token/contract-addresses
        asset({
            symbol: "USD1",
            token: "0x8d0d000ee44948fc98c9b98a4fa4921476f08b0d",
            decimals: 18,
            kind: "erc20",
        }),
    ]),
    // No mainnet addresses or invented stablecoin deployments on test chains.
    97: Object.freeze([asset({ symbol: "BNB", token: zeroAddress, decimals: 18, kind: "native" })]),
    31_337: Object.freeze([
        asset({ symbol: "ETH", token: zeroAddress, decimals: 18, kind: "native" }),
    ]),
});
export function getFundraisingAssets(chainId) {
    return FUNDRAISING_ASSETS[chainId] ?? [];
}
export function findFundraisingAsset(chainId, token) {
    return getFundraisingAssets(chainId).find((candidate) => candidate.token.toLowerCase() === token.toLowerCase());
}
//# sourceMappingURL=fundraisingAssets.js.map